import React from "react";
import { WorldMap } from "grommet";
import "./blog.css";

const Blog = () => {
  const testimonials = [
    {
      name: "Alice Johnson",
      role: "Marketing Manager",
      feedback: "Explooration helped us expand globally with confidence!",
      img: "/images/avatars/person1.jpg",
    },
    {
      name: "Mohamed Ali",
      role: "Software Engineer",
      feedback: "Great collaboration, smooth process, and reliable results.",
      img: "/images/avatars/person2.jpg",
    },
    {
      name: "Sofia Martinez",
      role: "Entrepreneur",
      feedback: "A trusted partner that truly understands innovation.",
      img: "/images/avatars/person3.jpg",
    },
    {
      name: "David Kim",
      role: "Consultant",
      feedback: "Professional team and excellent customer support!",
      img: "/images/avatars/person4.jpg",
    },
    {
      name: "Emma Brown",
      role: "Project Manager",
      feedback: "They guided us through every step of our journey.",
      img: "/images/avatars/person5.jpg",
    },
    {
      name: "James Wilson",
      role: "Investor",
      feedback: "An excellent partner with vision and dedication.",
      img: "/images/avatars/person6.jpg",
    },
  ];

  return (
    <div className="blog-container">
      {/* World map as background */}
      <div className="worldmap-background">
        <WorldMap
          color="graph-0"
          places={[
            {
              name: "Tunisia",
              location: [35.825603, 10.608395],
              color: "graph-2",
            },
          ]}
          selectColor="brand"
        />
      </div>

      {/* Content */}
      <div className="blog-content">
        <h1>What People Say About Us</h1>
        <div className="testimonial-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <img src={t.img} alt={t.name} className="profile-pic" />
              <h3>{t.name}</h3>
              <p className="role">{t.role}</p>
              <p className="feedback">“{t.feedback}”</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
